// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
mgt-tasks,
:host {
  font-family: var(--default-font-family, "Segoe UI");
  display: flex;
  flex-direction: column;
  background-color: var(--tasks-background-color, #f8f8f8);
  padding: var(--tasks-padding, 12px); }

mgt-tasks .TaskIcon,
:host .TaskIcon {
  font-family: 'FabricMDL2Icons';
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none; }

mgt-tasks .Header,
:host .Header {
  padding: var(--tasks-header-padding, 0);
  margin: var(--tasks-header-margin, 0 0 12px 0); }

mgt-tasks .TaskIcon.Divider,
:host .TaskIcon.Divider {
  vertical-align: initial;
  margin: 0 12px;
  font-size: 16px; }

mgt-tasks .Header,
:host .Header {
  padding: var(--tasks-title-padding, 0);
  display: flex;
  align-items: center; }

mgt-tasks select,
:host select {
  font-family: var(--default-font-family, "Segoe UI");
  border: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer; }

mgt-tasks select::-ms-expand,
:host select::-ms-expand {
  display: none; }

mgt-tasks select,
:host select,
mgt-tasks .Header .PlanTitle,
:host .Header .PlanTitle {
  font-family: var(--default-font-family, "Segoe UI");
  font-size: var(--tasks-plan-title-font-size, 1.1em);
  padding: var(--tasks-plan-title-padding, 5px); }

mgt-tasks .Header .AddBar,
:host .Header .AddBar {
  display: flex; }

mgt-tasks .Header .AddBar .AddBarItem,
:host .Header .AddBar .AddBarItem {
  flex: 1 1 auto; }

mgt-tasks .Header .NewTaskDue,
:host .Header .NewTaskDue {
  display: flex; }

mgt-tasks .Header .NewTaskDue input,
:host .Header .NewTaskDue input {
  flex: 1 1 auto; }

mgt-tasks .Header .TitleCont,
:host .Header .TitleCont {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  height: var(--tasks-new-button-height, 34px); }

mgt-tasks .Header .NewTaskButton,
:host .Header .NewTaskButton {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--task-new-button-width, auto);
  height: var(--tasks-new-button-height, 32px);
  border-radius: 2px;
  padding: 0 20px;
  background: var(--tasks-new-button-background, #0078d4);
  border: var(--tasks-new-button-border, solid 1px rgba(0, 0, 0, 0));
  color: var(--tasks-new-button-color, #ffffff);
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: pointer; }
  mgt-tasks .Header .NewTaskButton span,
  :host .Header .NewTaskButton span {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.1px;
    line-height: 14px; }
  mgt-tasks .Header .NewTaskButton .TaskIcon,
  :host .Header .NewTaskButton .TaskIcon {
    margin-right: 8px; }

mgt-tasks .Header .NewTaskButton:hover,
:host .Header .NewTaskButton:hover {
  background: var(--tasks-new-button-hover-background, #106ebe); }

mgt-tasks .Header .NewTaskButton:active,
:host .Header .NewTaskButton:active {
  background: var(--tasks-new-button-active-background, #005a9e); }

mgt-tasks .Task,
:host .Task {
  position: relative;
  margin: var(--task-margin, 0 0 18px 0);
  padding: var(--task-padding, 0 0 0 0);
  background-color: var(--task-background, white); }
  mgt-tasks .Task .TaskContent,
  :host .Task .TaskContent {
    display: flex; }
    mgt-tasks .Task .TaskContent .Divider,
    :host .Task .TaskContent .Divider {
      position: absolute;
      height: 2px;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #edebe9; }
    mgt-tasks .Task .TaskContent .TaskDetailsContainer,
    :host .Task .TaskContent .TaskDetailsContainer {
      flex: 1;
      display: grid;
      display: -ms-grid;
      grid-template-columns: auto 1fr;
      -ms-grid-columns: auto 1fr;
      grid-template-rows: auto auto auto auto;
      -ms-grid-rows: auto auto auto auto;
      justify-content: space-between;
      align-items: flex-start;
      color: var(--task-detail-color, #605e5c);
      font-size: 12px;
      font-weight: 600;
      white-space: nowrap;
      margin-bottom: 12px; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskDetail,
      :host .Task .TaskContent .TaskDetailsContainer .TaskDetail {
        width: 100%;
        height: 100%;
        margin: 4px 24px 6px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskTitle,
      :host .Task .TaskContent .TaskDetailsContainer .TaskTitle {
        color: var(--task-title-color, #323130);
        font-size: 14px;
        font-weight: 600;
        grid-row: 1;
        -ms-grid-row: 1;
        grid-column: 1 / 3;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2;
        margin: 22px 0 4px; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskGroup,
      :host .Task .TaskContent .TaskDetailsContainer .TaskGroup {
        min-height: 24px;
        grid-row: 2;
        -ms-grid-row: 2;
        grid-column: 1;
        -ms-grid-column: 1; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskBucket,
      :host .Task .TaskContent .TaskDetailsContainer .TaskBucket {
        min-height: 24px;
        grid-row: 2;
        -ms-grid-row: 2;
        grid-column: 2;
        -ms-grid-column: 2; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskAssignee,
      :host .Task .TaskContent .TaskDetailsContainer .TaskAssignee {
        grid-row: 3;
        -ms-grid-row: 3;
        grid-column: 1 / 3;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskAssignee mgt-people,
        :host .Task .TaskContent .TaskDetailsContainer .TaskAssignee mgt-people {
          --list-margin: 0; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskDue,
      :host .Task .TaskContent .TaskDetailsContainer .TaskDue {
        justify-content: flex-end;
        align-items: flex-start;
        grid-row: 4;
        -ms-grid-row: 4;
        grid-column: 1 / 3;
        -ms-grid-column: 1;
        -ms-grid-column-span: 2; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet,
      :host .Task .TaskContent .TaskDetailsContainer.tablet {
        grid-template-columns: 1fr 0.5fr 1fr 0.5fr;
        -ms-grid-columns: 1fr 0.5fr 1fr 0.5fr;
        grid-template-rows: auto auto;
        -ms-grid-rows: auto auto; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet.NoPlan,
        :host .Task .TaskContent .TaskDetailsContainer.tablet.NoPlan {
          grid-template-columns: 0 1fr 1fr 1fr;
          -ms-grid-columns: 0 1fr 1fr 1fr; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet .TaskDetail,
        :host .Task .TaskContent .TaskDetailsContainer.tablet .TaskDetail {
          margin: 4px 24px 6px 0; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet .TaskTitle,
        :host .Task .TaskContent .TaskDetailsContainer.tablet .TaskTitle {
          grid-row: 1;
          -ms-grid-row: 1;
          grid-column: 1 / 5;
          -ms-grid-column: 1;
          -ms-grid-column-span: 4; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet .TaskGroup,
        :host .Task .TaskContent .TaskDetailsContainer.tablet .TaskGroup {
          grid-row: 2;
          -ms-grid-row: 2;
          grid-column: 1;
          -ms-grid-column: 1; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet .TaskBucket,
        :host .Task .TaskContent .TaskDetailsContainer.tablet .TaskBucket {
          grid-row: 2;
          -ms-grid-row: 2;
          grid-column: 2;
          -ms-grid-column: 2; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet .TaskAssignee,
        :host .Task .TaskContent .TaskDetailsContainer.tablet .TaskAssignee {
          grid-row: 2;
          -ms-grid-row: 2;
          grid-column: 3;
          -ms-grid-column: 3; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.tablet .TaskDue,
        :host .Task .TaskContent .TaskDetailsContainer.tablet .TaskDue {
          justify-content: flex-start;
          align-items: center;
          grid-row: 2;
          -ms-grid-row: 2;
          grid-column: 4;
          -ms-grid-column: 4; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop,
      :host .Task .TaskContent .TaskDetailsContainer.desktop {
        grid-template-columns: 2fr 1fr 0.5fr 1fr 0.5fr;
        -ms-grid-columns: 2fr 1fr 0.5fr 1fr 0.5fr;
        grid-template-rows: auto;
        -ms-grid-rows: auto;
        margin: 0; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop.NoPlan,
        :host .Task .TaskContent .TaskDetailsContainer.desktop.NoPlan {
          grid-template-columns: 2fr 0 1fr 1fr 1fr;
          -ms-grid-columns: 2fr 0 1fr 1fr 1fr; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop .TaskDetail,
        :host .Task .TaskContent .TaskDetailsContainer.desktop .TaskDetail {
          margin: 0 24px 0 0; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop .TaskTitle,
        :host .Task .TaskContent .TaskDetailsContainer.desktop .TaskTitle {
          padding: 0;
          grid-row: 1;
          -ms-grid-row: 1;
          grid-column: 1;
          -ms-grid-column: 1; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop .TaskGroup,
        :host .Task .TaskContent .TaskDetailsContainer.desktop .TaskGroup {
          min-height: 61px;
          grid-row: 1;
          -ms-grid-row: 1;
          grid-column: 2;
          -ms-grid-column: 2; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop .TaskBucket,
        :host .Task .TaskContent .TaskDetailsContainer.desktop .TaskBucket {
          grid-row: 1;
          -ms-grid-row: 1;
          grid-column: 3;
          -ms-grid-column: 3; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop .TaskAssignee,
        :host .Task .TaskContent .TaskDetailsContainer.desktop .TaskAssignee {
          grid-row: 1;
          -ms-grid-row: 1;
          grid-column: 4;
          -ms-grid-column: 4; }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer.desktop .TaskDue,
        :host .Task .TaskContent .TaskDetailsContainer.desktop .TaskDue {
          justify-content: flex-start;
          align-items: center;
          grid-row: 1;
          -ms-grid-row: 1;
          grid-column: 5;
          -ms-grid-column: 5; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer svg,
      :host .Task .TaskContent .TaskDetailsContainer svg {
        vertical-align: middle;
        margin-right: 4px; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer span,
      mgt-tasks .Task .TaskContent .TaskDetailsContainer select,
      :host .Task .TaskContent .TaskDetailsContainer span,
      :host .Task .TaskContent .TaskDetailsContainer select {
        vertical-align: middle; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .TaskIcon,
      :host .Task .TaskContent .TaskDetailsContainer .TaskIcon {
        color: #797775;
        margin-right: 8px; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer mgt-people,
      :host .Task .TaskContent .TaskDetailsContainer mgt-people {
        color: var(--task-detail-color, black);
        font-size: 16px; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer mgt-person,
      :host .Task .TaskContent .TaskDetailsContainer mgt-person {
        display: inline-block; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer .Picker,
      :host .Task .TaskContent .TaskDetailsContainer .Picker {
        background-color: white;
        -webkit-background-clip: padding-box;
        -moz-background-clip: padding-box;
        background-clip: padding-box;
        width: var(--mgt-flyout-set-width, 350px);
        color: var(--task-detail-color, black); }
        mgt-tasks .Task .TaskContent .TaskDetailsContainer .Picker mgt-people-picker,
        :host .Task .TaskContent .TaskDetailsContainer .Picker mgt-people-picker {
          --separator-margin: 0px 10px 0px 10px; }
      mgt-tasks .Task .TaskContent .TaskDetailsContainer input,
      mgt-tasks .Task .TaskContent .TaskDetailsContainer select,
      :host .Task .TaskContent .TaskDetailsContainer input,
      :host .Task .TaskContent .TaskDetailsContainer select {
        color: var(--task-detail-color, #767676);
        font-size: 0.9em; }
  mgt-tasks .Task .TaskHeader,
  :host .Task .TaskHeader {
    display: flex;
    justify-content: center;
    color: var(--task-header-color, #333333);
    margin: var(--task-header-margin, 0 0 0 10px); }
  mgt-tasks .Task.ReadOnly .TaskCheckContainer,
  :host .Task.ReadOnly .TaskCheckContainer {
    cursor: default; }
  mgt-tasks .Task.Complete,
  :host .Task.Complete {
    background: var(--task-complete-background, #edebe9); }
  mgt-tasks .Task.NewTask,
  :host .Task.NewTask {
    margin: var(--task-new-margin, var(--task-margin, 0 0 24px 0));
    display: flex;
    flex-direction: row; }
    mgt-tasks .Task.NewTask .SelfAssign,
    :host .Task.NewTask .SelfAssign {
      display: none; }
    mgt-tasks .Task.NewTask .AssignTo,
    :host .Task.NewTask .AssignTo {
      border: 0;
      background: none; }
    mgt-tasks .Task.NewTask .FakeCheckBox,
    :host .Task.NewTask .FakeCheckBox {
      width: 15px;
      height: 15px;
      cursor: pointer;
      margin: 0 5px 0 5px; }
      mgt-tasks .Task.NewTask .FakeCheckBox::after,
      :host .Task.NewTask .FakeCheckBox::after {
        font-family: 'FabricMDL2Icons';
        content: '\uE739'; }
      mgt-tasks .Task.NewTask .FakeCheckBox ~ :checked,
      :host .Task.NewTask .FakeCheckBox ~ :checked {
        font-family: 'FabricMDL2Icons';
        content: '\uE73A'; }
    mgt-tasks .Task.NewTask .TaskContent,
    :host .Task.NewTask .TaskContent {
      flex: 1 1 auto;
      align-content: center;
      vertical-align: middle;
      margin: 0 0 0 12px; }
      mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer,
      :host .Task.NewTask .TaskContent .TaskDetailsContainer {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        margin: 0; }
        mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle,
        :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle {
          display: flex; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input {
            flex: 1;
            font-family: var(--default-font-family, "Segoe UI");
            margin: var(--task-new-input-margin, 0 24px 0 16px);
            padding: var(--task-new-input-padding, 6px);
            font-size: var(--task-new-input-font-size, 14px);
            font-weight: 600;
            border: var(--task-new-border, none);
            border-bottom: 1px solid #e1dfdd;
            outline: none;
            border-radius: 0; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input:hover,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input:hover {
            border-bottom: 1px solid #106ebe; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input:active,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input:active {
            border-bottom: 1px solid #005a9e; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input:focus,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskTitle input:focus {
            border-bottom: 1px solid #0078d4; }
        mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails,
        :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails {
          display: flex;
          justify-content: stretch;
          align-items: center;
          flex-wrap: wrap;
          margin: 14px 0 14px 4px; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskGroup,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskGroup {
            margin: 8px 16px; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskBucket,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskBucket {
            margin: 8px 16px; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskDue,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskDue {
            margin: 8px 16px; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskAssignee,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .NewTaskAssignee {
            margin: 8px 16px;
            min-width: 80px; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .TaskPeople label,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails .TaskPeople label {
            display: flex;
            align-content: center;
            align-items: center; }
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select,
          mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select,
          :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input {
            font-family: var(--default-font-family, "Segoe UI");
            font-size: 12px;
            font-weight: 600;
            border: var(--task-new-select-border, none);
            border-bottom: 1px solid #e1dfdd;
            outline: none;
            border-radius: 0;
            padding: 4px; }
            mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select:hover,
            mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input:hover,
            :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select:hover,
            :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input:hover {
              border-bottom: 1px solid #106ebe; }
            mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select:active,
            mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input:active,
            :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select:active,
            :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input:active {
              border-bottom: 1px solid #005a9e; }
            mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select:focus,
            mgt-tasks .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input:focus,
            :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails select:focus,
            :host .Task.NewTask .TaskContent .TaskDetailsContainer .TaskDetails input:focus {
              border-bottom: 1px solid #0078d4; }
    mgt-tasks .Task.NewTask .TaskAddButtonContainer,
    :host .Task.NewTask .TaskAddButtonContainer {
      flex: 0 0 auto;
      display: flex; }
      mgt-tasks .Task.NewTask .TaskAddButtonContainer .TaskAdd,
      mgt-tasks .Task.NewTask .TaskAddButtonContainer .TaskCancel,
      :host .Task.NewTask .TaskAddButtonContainer .TaskAdd,
      :host .Task.NewTask .TaskAddButtonContainer .TaskCancel {
        height: 100%;
        max-width: 50px;
        min-width: 50px;
        flex: 1 1 auto;
        justify-content: center;
        align-items: center;
        display: flex;
        cursor: pointer; }
      mgt-tasks .Task.NewTask .TaskAddButtonContainer .TaskAdd,
      :host .Task.NewTask .TaskAddButtonContainer .TaskAdd {
        color: white;
        background: var(--task-new-add-button-background, #0078d4); }
      mgt-tasks .Task.NewTask .TaskAddButtonContainer .TaskCancel,
      :host .Task.NewTask .TaskAddButtonContainer .TaskCancel {
        font-family: var(--default-font-family, "Segoe UI");
        font-size: 14px;
        font-weight: 600;
        color: var(--task-new-cancel-button-color, #161514);
        margin: 0 12px 0 32px; }
      mgt-tasks .Task.NewTask .TaskAddButtonContainer.Disabled .TaskAdd,
      :host .Task.NewTask .TaskAddButtonContainer.Disabled .TaskAdd {
        background: var(--task-new-add-button-disabled-background, #eaeaea);
        cursor: default; }
  mgt-tasks .Task .TaskCheckContainer,
  :host .Task .TaskCheckContainer {
    font-family: 'FabricMDL2Icons';
    display: inline-block;
    border-radius: 50%;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: var(--task-icon-alignment, flex-start);
    margin: 21px 10px 20px 20px;
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none; }
    mgt-tasks .Task .TaskCheckContainer.Complete .TaskCheck,
    :host .Task .TaskCheckContainer.Complete .TaskCheck {
      background-color: var(--task-icon-background-completed, #00ad56);
      border: var(--task-icon-border-completed, solid 1px white);
      color: var(--task-icon-color-completed, white); }
  mgt-tasks .Task .TaskCheck,
  :host .Task .TaskCheck {
    font-family: 'FabricMDL2Icons';
    font-size: 12px;
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: var(--task-icon-border-radius, 50%);
    border: var(--task-icon-border, solid 1px #797775);
    color: var(--task-icon-color, black);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--task-icon-background, transparent);
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none; }
    mgt-tasks .Task .TaskCheck.Loading .TaskCheckContent,
    :host .Task .TaskCheck.Loading .TaskCheckContent {
      animation: rotateIcon 2s infinite linear; }
  mgt-tasks .Task.LoadingTask .TaskCheckContainer,
  :host .Task.LoadingTask .TaskCheckContainer {
    cursor: default; }
  mgt-tasks .Task.LoadingTask .TaskDetails,
  :host .Task.LoadingTask .TaskDetails {
    display: flex; }
  mgt-tasks .Task.LoadingTask .TaskCheck,
  :host .Task.LoadingTask .TaskCheck {
    background: #f2f2f2;
    border-color: #f2f2f2;
    cursor: default; }
  mgt-tasks .Task.LoadingTask .TaskHeader,
  :host .Task.LoadingTask .TaskHeader {
    justify-content: flex-start;
    justify-items: flex-start; }
  mgt-tasks .Task.LoadingTask .TaskDetailIcon,
  :host .Task.LoadingTask .TaskDetailIcon {
    width: 16px;
    height: 16px;
    margin: 5px;
    background: #f2f2f2; }
  mgt-tasks .Task.LoadingTask .TaskTitle,
  :host .Task.LoadingTask .TaskTitle {
    background: #f2f2f2;
    max-width: 400px;
    height: 20px;
    margin-right: 20px !important; }
  mgt-tasks .Task.LoadingTask .TaskDetail,
  :host .Task.LoadingTask .TaskDetail {
    margin-right: 12px;
    display: flex;
    flex-direction: row;
    align-items: center; }
  mgt-tasks .Task.LoadingTask .TaskDetailName,
  :host .Task.LoadingTask .TaskDetailName {
    width: 81px;
    height: 10px;
    background: #f2f2f2; }
  mgt-tasks .Task .TaskOptions,
  :host .Task .TaskOptions {
    cursor: pointer;
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    margin: 16px 8px 0 0; }

mgt-tasks .LoadingHeader,
:host .LoadingHeader {
  max-width: 90px;
  width: 100%;
  height: 20px;
  background: #f2f2f2; }

@keyframes rotateIcon {
  from {
    transform: rotate(0deg); }
  to {
    transform: rotate(360deg); } }

`
];
//# sourceMappingURL=mgt-tasks-css.js.map